import React, {useEffect, useState} from "react";
import "./Nav.scss";
import {useHistory} from "react-router-dom";
import SpeechRecognition, {useSpeechRecognition} from 'react-speech-recognition'
import {useDispatchRoot, useDispatchSpeech, useDispatchStore, usePrompt, useRoot, useStore} from "../../hooks";
import {AddToHomescreen} from "..";
import {isInStandaloneMode, isIos} from "../../Services/utils";
import {InstallData, NavDataApi, SetInstallData} from "./NavServices";
import {LogRequest} from "../../Services";
import {ChildButton, FloatingMenu, MainButton} from "react-floating-button-menu";

import {
    ClockCircleOutlined ,
    AppstoreAddOutlined ,
    BellOutlined,
    CreditCardOutlined,
    ExperimentOutlined

} from '@ant-design/icons';
import useWindowDimensions from "../../hooks/useWindowDimensions";


function Nav() {

    const history = useHistory();
    const {transcript, resetTranscript} = useSpeechRecognition()
    const setSpeech = useDispatchSpeech();
    const [speechState, setSpeechState] = useState(false);
    const [install, setInstall] = useState(false);
    const fire = useStore();
    const setFire = useDispatchStore();
    const prompt = usePrompt();
    const selected = useRoot();

    const [showModal, setShowModal] = useState(false);
    const [map, setMap] = useState(false);


    // let audio = new Audio("/other/digimall.mp3");


    const SpeechMode = ()=>{
        setSpeechState(true);
        setTimeout(()=>{
            setSpeechState(false);
        },5000)
    }


    //Vassistant
    const Vassistant = (word)=>{
        switch (word) {
            case 'جشنواره':
                history.push('/festivals');
                break;
            case 'دیجی مال':
                // audio.play();
                break;
            case 'دیجیمال':
                // audio.play();
                break;
            case 'پروفایل':
                history.push('/profile');
                break;
            case 'پشتیبانی':
                //call
                document.location.href="tel:"+989363565238;
                break;
            case 'جستجو':
                history.push('/store');
                break;
            case 'اسکن':
                history.push('/scan');
                break;
            case 'گزارش':
                history.push('/reward');
                break;
            case 'مسیریابی':
                //google
                mapsSelector();
                break;
            default:
                //dispatch speech
                setSpeech(transcript);
        }
    }

    const mapsSelector = () =>{
        if /* if we're on iOS, open in Apple Maps */
        ((navigator.platform.indexOf("iPhone") != -1) ||
            (navigator.platform.indexOf("iPad") != -1) ||
            (navigator.platform.indexOf("iPod") != -1))

            window.open("maps://maps.google.com/maps?daddr="+35.7624+","+51.3916+"&amp;ll=");
        else /* else use Google */
            window.open("https://maps.google.com/maps?daddr="+35.7624+","+51.3916+"&amp;ll=");
    }



    const ShowInstall = async () => {
        //show bundle
        setShowModal(true);

        //show prompt
        try {
            if(!fire){
                prompt.prompt().catch((e)=>{
                    // console.log("User Gust error")
                });
                const choiceResult = await prompt.userChoice;
                if (choiceResult.outcome === "accepted") {
                    // console.log("User accepted the PWA prompt");
                    setFire(true);
                } else {
                    // console.log("User dismissed the PWA prompt");
                    setFire(true);
                }
            }
        } catch (e) {
            //if user gesture error =>
            //scroll listen => after fetch event =>  remove scroll listener => fetch after 3 second => prompt()
            // console.log("Event Trigger : ",e)
        }
    }


    const CheckStandAloneMode = async () => {
        // console.log("IS standAlone : ",isInStandaloneMode())
        if(isInStandaloneMode()){
            try {
                //fetch install status
                let response = await InstallData();
                // console.log("Resp one : ",response);
                if (response.data.length<1) {
                    let setResponse = await SetInstallData();
                    LogRequest({type:"PWA_MODE",meta:""})
                    // console.log("Resp : ",setResponse);
                }
            } catch (e) {
                // console.log(e)
            }
        }
    }


    const CheckInstallApi = async () => {
        try {
            //fetch install status
            let response = await InstallData();
            console.log("Response install :", response.data);
            //check install status
            if (response.data.length>0) {
                //install => yes
                setShowModal(false);
            } else {
                //install => no
                //check standAlone
                //console.log("isInStandaloneMode :", isInStandaloneMode());
                if (isInStandaloneMode()) {
                    // IsStandAlone => yes
                    setShowModal(false);

                    //call Api for set install status
                    let setResponse = await SetInstallData()
                    console.log("Set Res: ",setResponse)
                } else {
                    // IsStandAlone => no

                    //disable for notification faze
                        //ShowInstall().then()
                    setShowModal(true);
                }
            }
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(()=>{
        // console.log("res : ",transcript);
        if(transcript.length>1){
            Vassistant(transcript)


        }
    },[transcript])


    useEffect(()=>{
        let Mall = localStorage.getItem('mall');
        if(Mall){
            let parsedMall = JSON.parse(Mall);
            if(parsedMall.show_map){
                setMap(parsedMall.show_map)
            }
        }

    },[])

    useEffect(() => {
        //check StandAloneMode
        CheckStandAloneMode().then();

        //check init & listen Prompt

        if (prompt) {
            console.log("Nav Fetch Prompt", prompt);
            if(checkWait()){
                console.log("install wait is finished");
                CheckInstallApi().then();
            }else {
                 console.log("install wait not finish");
            }
        }else {
           console.log("----");
        }
    }, [prompt])


    const GoTo = (page,text) => {
        history.push("/" + page,{navLabel:text});
    }


    const isActive = (page) => {
        return "/" + page === selected
    }

    const checkWait = () =>{
        const wait = localStorage.getItem('installWait')
        if(wait){
            let waitParsed = JSON.parse(wait);
            let now = new Date().getDay().toString() + new Date().getMonth().toString();
            let last = waitParsed.date;
            //check wait
            return now!==last;
        }else {
            return true;
        }
    }

    const setWait = () =>{
        localStorage.setItem('installWait',JSON.stringify({
            date:new Date().getDay().toString() + new Date().getMonth().toString()
        }))
    }

    useEffect(()=>{
        set_call(false)
        getNav()
    },[])


    const [items,set_items] = useState(null)
    const [call,set_call] = useState(false)

    const [aPosition,set_aPosition] = useState({label:"خانه",link:"home",image:"/navbar/home_icon.svg",select_image:"/navbar/home_icon_select.svg"})
    const [bPosition,set_bPosition] = useState({label:"فروشگاه",link:"store",image:"/navbar/_store_icon.svg",select_image:"/navbar/store_icon_select.svg"})
    const [cPosition,set_cPosition] = useState({label:"اسکن",link:"scan",image:"/navbar/_scan_icon.svg",select_image:"/navbar/scan_icon_select.svg"})
    const [dPosition,set_dPosition] = useState({label:"پاداش",link:"reward",image:"/navbar/gift_icon.svg",select_image:"/navbar/gift_icon_select.svg"})

    const getNav = async()=>{
        try{
            const res= await NavDataApi()
            if(res.data.length>0 && res.data[0].items.length > 0){
                let data = res.data[0].items ;
                // A position
                let ap = data.find(d=>d.position==="right")
                if(ap)
                    set_aPosition({...aPosition,label:ap.title,link:ap.link_to_uid,image:ap.image?ap.image:aPosition.image,select_image:ap.select_image?ap.select_image:aPosition.select_image})

                // B position
                let bp = data.find(d=>d.position==="right_top")
                if(bp)
                    set_bPosition({...bPosition,label:bp.title,link:bp.link_to_uid,image:bp.image?bp.image:bPosition.image,select_image:bp.select_image?bp.select_image:bPosition.select_image})

                // C position
                let cp = data.find(d=>d.position==="left")
                if(cp)
                    set_cPosition({...cPosition,label:cp.title,link:cp.link_to_uid,image:cp.image?cp.image:cPosition.image,select_image:cp.select_image?cp.select_image:cPosition.select_image})

                // D position
                let dp = data.find(d=>d.position==="left_top")
                if(dp)
                    set_dPosition({...dPosition,label:dp.title,link:dp.link_to_uid,image:dp.image?dp.image:dPosition.image,select_image:dp.select_image?dp.select_image:dPosition.select_image})
            }
            set_call(true)
        }catch(e){
            set_call(true)
            console.log("e",e)
        }
    }
    const { height, width,mobileWidth } = useWindowDimensions();

    const [isOpen, set_isOpen] = useState(false);

    return (
        <div>
            <div className="Nav_container" style={{width:mobileWidth?mobileWidth:document?.getElementById('mobile-sec')?.clientWidth}}>

                {call?<div className="Nav_container-nested">

                    <div className="nav_item" onClick={() => GoTo(dPosition.link,dPosition.label)}>
                        <img
                            src={isActive(dPosition.link) ? dPosition.select_image : dPosition.image}
                            alt=""/>
                        <span className={isActive(dPosition.link) ? "active-nav" : ""}>{dPosition.label}</span>
                    </div>

                    <div className="nav_item" onClick={() => GoTo(cPosition.link,cPosition.label)}>
                        <img src={isActive(cPosition.link) ? cPosition.select_image : cPosition.image} alt=""/>
                        <span className={isActive(cPosition.link) ? "active-nav" : ""}>{cPosition.label}</span>
                    </div>

                    {/*<div className="nav_item" >*/}
                    {/*    <div className="float-menu">*/}
                    {/*        <FloatingMenu*/}
                    {/*            slideSpeed={500}*/}
                    {/*            direction="up"*/}
                    {/*            spacing={8}*/}
                    {/*            isOpen={isOpen}*/}
                    {/*        >*/}
                    {/*            <MainButton*/}
                    {/*                iconResting={<AppstoreAddOutlined style={{color:"white",fontSize:30,marginTop:0}} />}*/}
                    {/*                iconActive={<AppstoreAddOutlined style={{fontSize:30,marginTop:0}} />}*/}
                    {/*                backgroundColor="#999999"*/}
                    {/*                onClick={() => set_isOpen(!isOpen)}*/}
                    {/*                size={56}*/}
                    {/*                color="white"*/}
                    {/*            />*/}
                    {/*            <ChildButton*/}
                    {/*                icon={<BellOutlined style={{fontSize:24,marginTop:0}} />}*/}
                    {/*                backgroundColor="white"*/}
                    {/*                size={40}*/}
                    {/*                onClick={() => console.log('First button clicked')}*/}
                    {/*                color="white"*/}
                    {/*            />*/}
                    {/*            <ChildButton*/}
                    {/*                icon={<CreditCardOutlined style={{fontSize:24,marginTop:0}} />}*/}
                    {/*                backgroundColor="white"*/}
                    {/*                onClick={() => console.log('sec button clicked')}*/}
                    {/*                size={40}*/}
                    {/*            />*/}
                    {/*            <ChildButton*/}
                    {/*                icon={<ExperimentOutlined style={{fontSize:24,marginTop:0}} />}*/}
                    {/*                backgroundColor="white"*/}
                    {/*                onClick={() => console.log('thrrr button clicked')}*/}
                    {/*                size={40}*/}
                    {/*            />*/}
                    {/*        </FloatingMenu>*/}
                    {/*    </div>*/}
                    {/*</div>*/}


                    <div className="nav_item" onClick={() => GoTo(bPosition.link,bPosition.label)}>
                        <img src={isActive(bPosition.link) ? bPosition.select_image : bPosition.image} alt=""/>
                        <span className={isActive(bPosition.link) ? "active-nav" : ""}>{bPosition.label}</span>
                    </div>


                    <div className="nav_item" onClick={() => GoTo(aPosition.link,aPosition.label)}>
                        <img src={isActive(aPosition.link) ? aPosition.select_image : aPosition.image} alt=""/>
                        <span className={isActive(aPosition.link) ? "active-nav" : ""}>{aPosition.label}</span>
                    </div>


                </div>:null}

                    {showModal?<div className="add-to-home-banner">
                        <img className="add-to-home-icon" src="/other/close.png" onClick={
                            ()=>{
                                setWait()
                                setShowModal(false)
                            }}/>
                        <div className="add-to-home-content" onClick={async()=>{
                                setWait()
                                prompt.prompt().catch((e)=>{
                                    // console.log("User Gust error")
                                });
                                const choiceResult = await prompt.userChoice;
                                if (choiceResult.outcome === "accepted") {
                                    // console.log("User accepted the PWA prompt");
                                    LogRequest({type:"PWA_INSTALL_DIALOG",meta:"accepted"})
                                } else {
                                    // console.log("User dismissed the PWA prompt");
                                    LogRequest({type:"PWA_INSTALL_DIALOG",meta:"deny"})
                                }
                        }}>
                            <div className="add-to-home-text">
                                <a>
                                    {'اپلیکیشن را بروی گوشی نصب نمایید'}
                                </a>
                            </div>
                            <img src="/other/install.png" alt="" style={{width:30}}/>
                        </div>
                    </div>:null}
                {/*<div className="speech-nav">*/}
                {/*    {!speechState?<i className="fa fa-microphone"*/}
                {/*                    onClick={()=>{*/}
                {/*                        SpeechRecognition.startListening({ language: 'fa-IR' })*/}
                {/*                        SpeechMode()*/}
                {/*                    }}*/}
                {/*    ></i>:<i className="fa fa-microphone" style={{color:"orange"}}></i>}*/}
                {/*</div>*/}
            </div>
        </div>
    )
}

export {Nav};
